(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.passwordmatch = "";
        vm.checkMinLngUser = true;

        // boolean variables to change password input box type
        vm.showPassword = false;
        vm.showConfirmPassword = false;

        Principal.identity().then(function(account) {
            vm.account = account;
        });
        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.password = "";
                    vm.confirmPassword = "";
                    //location.reload();
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
        vm.passwordmatch = function()
        {
            if(vm.password === vm.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser =  (vm.password !== vm.confirmPassword);
        }

        /*vm.reset = function (){
            var x = document.getElementById("password");
            var y = document.getElementById("confirmPassword");
            console.log(x,y);
        }*/
    }

})();
